
import { apiErrorCode, apiErrorDetails } from '../../utils/apiError';

const PAIR_RULES = new Set([
  'insufficient_item_value',
  'item_price_too_low',
  'upgrade_probability_out_of_range',
  'upgrade_coefficient_too_high',
]);

export type UpgradeRefusal =
  | 'item-used'
  | 'item-gone'
  | 'pair-rejected'
  | 'no-funds'
  | 'unknown';

export function upgradeRefusal(err: unknown): UpgradeRefusal {
  const rule = apiErrorDetails(err)?.rule;
  if (typeof rule === 'string') {
    if (rule === 'item_not_owned') return 'item-used';
    if (PAIR_RULES.has(rule)) return 'pair-rejected';
  }

  switch (apiErrorCode(err)) {
    case 'INVALID_OPERATION':
      return 'item-used';
    case 'ENTITY_NOT_FOUND':
      return 'item-gone';
    case 'INSUFFICIENT_RESOURCES':
      return 'no-funds';
    default:
      return 'unknown';
  }
}

export const needsInventoryRefresh = (refusal: UpgradeRefusal): boolean =>
  refusal === 'item-used' || refusal === 'item-gone';
